import {FieldResultAggregatedProps} from "../types/domain/fieldResult";
import {WeatherProps} from "../types/weatherProps";

export const isSoilMoistureAlert = (
    soilMoisturePercentage: number,
    threshold: number,
    vegetationCover: number | undefined,
) => {
    if (vegetationCover != null && vegetationCover != undefined && vegetationCover < 20) {
        return false;
    }
    return soilMoisturePercentage <= threshold * 100;
};

export const soilMoistureAlertColor = (
    soilMoisturePercentage: number,
    threshold: number,
    vegetationCover: number | undefined,
) => {
    if (vegetationCover != null && vegetationCover != undefined && vegetationCover < 20) {
        return "#A6FFFB";
    }
    if (isSoilMoistureAlert(soilMoisturePercentage, threshold, vegetationCover)) {
        return "#F89083";
    } else if (isSoilOversaturated(soilMoisturePercentage)) {
        return "#a8b0e0";
    } else {
        return "#A6FFFB";
    }
};

export const isSoilOversaturated = (soilMoisturePercentage: number) => soilMoisturePercentage > 100;

export const isCropGrowthAlert = (cropGrowthPercentage: number, vegetationCover: number | undefined) => {
    if (vegetationCover != null && vegetationCover != undefined && vegetationCover < 20) {
        return false;
    }
    return cropGrowthPercentage <= 70;
};
export const cropGrowthAlertColor = (cropGrowthPercentage: number, vegetationCover: number | undefined): string => {
    if (vegetationCover != null && vegetationCover != undefined && vegetationCover < 20) {
        return "#C3C3C3";
    }
    if (cropGrowthPercentage <= 70) {
        return "#F89083";
    }
    return "#b4ffd5";
};

export const normalizeSoilMoisture = (soilMoisturePercentage: number, limit = true) => {
    if (soilMoisturePercentage < 0) {
        return 0;
    } else {
        if (limit) {
            if (soilMoisturePercentage > 100) {
                return 100;
            }
        }
        return soilMoisturePercentage;
    }
};

export const normalizeCropGrowth = (cropGrowthPercentage: number) => {
    if (cropGrowthPercentage < 0) {
        return 0;
    } else if (cropGrowthPercentage > 100) {
        return 100;
    } else {
        return cropGrowthPercentage;
    }
};

export const aggregatedPropsToWeatherProps = (props: FieldResultAggregatedProps): WeatherProps => {
    return {
        temperature: props.air_temperature_24_T1,
        windSpeed: props.wind_speed_24_T1,
        humidity: props.relative_humidity_24_T1,
        appliedWater: props.applied_water,
        precipitation: props.p_fcdp0,
    };
};
